// 本来core内ではフレームワークに依存しないが、tanstack-queryは全てのフレームワークで設定が共通なのでcoreに置くことを許容する
import { QueryClient, MutationCache } from '@tanstack/vue-query';

export function createQueryClient() {
  const queryClient = new QueryClient({
    mutationCache: new MutationCache({
      onSuccess: async (_data, _variables, _context, mutation) => {
        await queryClient.invalidateQueries({ queryKey: mutation.options.mutationKey });
      },
    }),
  });

  return queryClient;
}
